const FormControlRules = {
  REQUIRED: 'required',
  PATTERN: 'pattern',
  EMAIL: 'email',
  ARRAY: 'array',
  LENGTH: 'length',
  MAXLENGTH: 'maxLength',
  POSITIVEINT: 'positiveint',
  EMAILMATCH: 'emailMatch',
  MAXNUMERIC: 'MAXNUMERIC',
  CURRENCY: 'currency',
  FUNCTION: 'function',
  URL: 'URL',
};

export default FormControlRules;
